import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/useMeterInput'
import PdlSearchButton from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchButton'

const MeterInput = () => {
  const { meterIdOnBlurHandler, pdlNo, isEditable, lastSentDate, canRequestMeterData, meterStatus, showPdlSearchButton, t } = useMeterInput()

  return (
    <>
      <FormControl>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate || canRequestMeterData}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pdlNo}
            label={pdlNo ? t('subscriptionForm:pdl_module.meter_id.label') : ''}
            placeholder={t('subscriptionForm:pdl_module.meter_id.placeholder')}
            status={meterStatus}
          />
          <PdlSearchButton hidden={!showPdlSearchButton} />
        </>
      </FormControl>
    </>
  )
}

export default MeterInput
